module.exports = __webpack_public_path__ + "media/images/btn_preview-ae1758b9af04fc6c68a3a96758e11da2.gif";